import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIntegrations = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.26647 10.1667C5.34705 10.1667 4.46529 9.80143 3.81517 9.1513C3.16504 8.50118 2.7998 7.61942 2.7998 6.7V4.96667C2.7998 4.73681 2.89111 4.51637 3.05365 4.35384C3.21618 4.19131 3.43662 4.1 3.66647 4.1H8.86647C9.09633 4.1 9.31677 4.19131 9.4793 4.35384C9.64183 4.51637 9.73314 4.73681 9.73314 4.96667V6.7C9.73314 7.15525 9.64347 7.60604 9.46925 8.02664C9.29504 8.44723 9.03968 8.82939 8.71777 9.1513C8.39586 9.47321 8.0137 9.72857 7.59311 9.90278C7.17251 10.077 6.72172 10.1667 6.26647 10.1667ZM6.26647 10.1667V11.9C6.26647 12.3597 6.44909 12.8006 6.77415 13.1257C7.09922 13.4507 7.5401 13.6333 7.9998 13.6333C8.45951 13.6333 8.90039 13.4507 9.22546 13.1257C9.55052 12.8006 9.73314 12.3597 9.73314 11.9C9.73314 11.4403 9.91576 10.9994 10.2408 10.6743C10.5659 10.3493 11.0068 10.1667 11.4665 10.1667C11.9262 10.1667 12.3671 10.3493 12.6921 10.6743C13.0172 10.9994 13.1998 11.4403 13.1998 11.9V14.5M4.53314 4.1V1.5M7.9998 4.1V1.5M5.3998 5.83333H7.13314",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgIntegrations;
